import { Countries } from "types/Models/countries";
import { array, number, object, string } from "yup";
import { addressAutofill } from "./autofillSchema";

export const vendorAddSchema = (countries: Countries[] = []) =>
  object({
    name: string().required("Name is required"),
    email: string().notRequired().email("Should be a valid email"),
    address_obj: object().when("is_add_billing_address", {
      is: true,
      then: addressAutofill(countries),
      otherwise: object().nullable(),
    }),
    payment_instructions: string().when("is_add_payment_instructions", {
      is: true,
      then: string().required("Payment instructions are required"),
      otherwise: string().nullable(),
    }),
  });

export const bulkVendorAddSchema = object({
  merchants: array().of(
    object({
      name: string().required("Name is required"),
      email: string().nullable().notRequired().email("Should be a valid email"),
    })
  ),
});

export const vendorEditSchema = object({
  name: string().required("Name is required"),
  email: string().notRequired().email("Should be a valid email"),
});

export const merchantEmailAddSchema = () =>
  object({
    email: string()
      .required("Email is required")
      .email("Should be a valid email"),
  });

export const vendorEditDetailsSchema = object({
  name: string().required("Name is required"),
  email: string().email("Should be a valid email"),
  address: string(),
  payment_instructions: string().notRequired(),
  currency: string().notRequired(),
  total_amount: number().required("Amount paid is required"),
});
